import { FlexMixin } from '@ui-kit/styles/common/mixins/helpers.styled';
import styled from 'styled-components';

export const Main = styled.main`
	${FlexMixin({ direction: 'column' })}
	gap: 20px;
	padding-bottom: 20px;
	background-color: ${({ theme }) => theme.colors.white.base};
`;
